// extracted by mini-css-extract-plugin
module.exports = {"ToggleButton":"styles_ToggleButton__3-zJV","inputBlock":"styles_inputBlock__2MCDb","loaderBlock":"styles_loaderBlock__UvLa_","input":"styles_input__3amaN"};